export interface SavedItemViewModel {
  id: number;
  description: string;
  url: string;
  markedForDeletion: boolean;
}

export enum SavedItemType {
  Topics = 'Topics',
  Documents = 'Documents',
  Searches = 'Searches'
}
